import { format, parse, parseISO } from 'date-fns';

const TIME_FORMAT = 'HH:mm';
export const parseTime = (time: string) => parse(time, TIME_FORMAT, new Date());

export const formatDate = (
  dateString: string,
  dateFormat: string = 'EEEE, d MMMM'
) => {
  let formattedDate = '';

  try {
    formattedDate = format(parseISO(dateString), dateFormat);
  } catch {
    formattedDate = '';
  }

  return formattedDate;
};

export const formatTime = (timeString: string, timeFormat: string = 'p') => {
  let formattedTime = '';

  try {
    formattedTime = format(parseTime(timeString), timeFormat);
  } catch {
    formattedTime = '';
  }

  return formattedTime;
};

export const getSecondsInADay = (seconds: number) => {
  return seconds / 86400;
};

export const formatToTime = (timeString: string) => {
  const dateTime = parseISO(timeString);
  let timeVariable = '';
  try {
    timeVariable = format(dateTime, 'hh:mmaaa');
  } catch {
    timeVariable = '';
  }
  return timeVariable;
};
